import { useState } from 'react';
import { KTCard } from '../../../../../_metronic/helpers';
import { ToastTopLeft } from '../../../components/ToastTopLeft';
import { SubscriptionModalState } from '../model/types';
import { SubscriptionTable } from './ui/SubsribtionTable'
import { SubscriptionModal } from '../subsribtion-modal/ui/SubscriptionModal'

export const SubscriptionPage = () => {
	const [openModal, setOpenModal] = useState<SubscriptionModalState | null>(
		null
	);
	const [showErrorToast, setShowErrorToast] = useState(false);

	const handleModalClose = () => {
		setOpenModal(null);
	};

	return (
		<KTCard className='w-100'>
			<SubscriptionTable openModal={openModal} setOpenModal={setOpenModal} />

			{openModal && (
				<SubscriptionModal
					openModal={openModal}
					handleModalClose={handleModalClose}
					setShowErrorToast={setShowErrorToast}
				/>
			)}

			<ToastTopLeft
				showToast={showErrorToast}
				setShowToast={setShowErrorToast}
				state='danger'
			/>
		</KTCard>
	);
};
